/**
 * Google Analytics (gtag.js) Early Initialization
 * 
 * This file initializes Google Analytics gtag.js before React loads.
 * It's processed by Vite, so import.meta.env values are replaced at build time.
 * 
 * This provides early tracking before the React app initializes,
 * complementing the ReactGA implementation in src/utils/analytics.js
 */

// Get environment variables (replaced by Vite at build time)
const gaMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
const appEnv = import.meta.env.VITE_APP_ENV;
const isProduction = appEnv === 'production';
const isStaging = appEnv === 'staging';

// Only initialize if we have a measurement ID and we're in production/staging
if (gaMeasurementId && (isProduction || isStaging)) {
  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`;
  document.head.appendChild(script);
  
  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(){dataLayer.push(arguments);}
  window.gtag('js', new Date());
  window.gtag('config', gaMeasurementId);
  
  // Optional: Log in staging for debugging
  if (isStaging) {
    console.log('[gtag-init] Google Analytics initialized with ID:', gaMeasurementId);
  }
} else if (import.meta.env.DEV) {
  console.log('[gtag-init] Google Analytics disabled (development mode or missing measurement ID)');
}

